import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { ClientDTO } from 'src/app/base/models/models.swagger.generated';
import { ClientAutocompleteComponent } from 'src/app/base/shared/client-autocomplete/client-autocomplete.component';

@Component({
  selector: "app-theme-client-switcher",
  imports: [ClientAutocompleteComponent, DialogModule, TranslatePipe,],
  templateUrl: "./theme-client-switcher.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./theme-client-switcher.component.scss",
})
export class ThemeClientSwitcherComponent {
  @Input() public selectedClient: ClientDTO | null = null;
  @Input() public isClientThemeDirty: boolean = false;
  @Output() public selectedClientChange: EventEmitter<ClientDTO | null> =
    new EventEmitter<ClientDTO | null>();

  public isUnsavedChangesDialogOpen = false;
  private pendingClientSelection: ClientDTO | null = null;

  public onSelectedClientChange(client: ClientDTO | null): void {
    if (this.isClientThemeDirty) {
      this.pendingClientSelection = client;
      this.isUnsavedChangesDialogOpen = true;
      return;
    }

    this.applyClientSelection(client);
  }

  public confirmClientSwitch(): void {
    this.isUnsavedChangesDialogOpen = false;
    this.applyClientSelection(this.pendingClientSelection);
    this.pendingClientSelection = null;
  }

  public cancelClientSwitch(): void {
    this.isUnsavedChangesDialogOpen = false;
    this.pendingClientSelection = null;
  }

  private applyClientSelection(client: ClientDTO | null): void {
    this.selectedClient = client;
    this.selectedClientChange.emit(client);
  }
}
